import React, { createContext, useContext, useState } from 'react';
import { FlatCardData } from '../../components/CardsComponents/types';

const FlatContext = createContext<{
  flat: FlatCardData | null;
  setFlat: (flat: FlatCardData | null) => void;
  selectedOption: 'full' | 'installment';
  setSelectedOption: (option: 'full' | 'installment') => void;
}>({ flat: null, setFlat: () => {}, selectedOption: 'full', setSelectedOption: () => {} });

export const FlatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [flat, setFlat] = useState<FlatCardData | null>(null);
  const [selectedOption, setSelectedOption] = useState<'full' | 'installment'>('full');
  return (
    <FlatContext.Provider value={{ flat, setFlat, selectedOption, setSelectedOption }}>
      {children}
    </FlatContext.Provider>
  );
};

export const useFlat = () => useContext(FlatContext);